import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';

const Tips0Field: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	if (restaurantForFullInfo?.defaultTips[0]) {
		return (
			<FullInfoField
				label={restaurantForFullInfo.defaultTips[0].isDefault ? 'tips0DefaultLabel' : 'tips0Label'}
				value={restaurantForFullInfo.defaultTips[0].value}
			/>
		);
	}
	return <FullInfoField label="tips0Label" value={null} />;
};

export default Tips0Field;
